import {Typography, useTheme} from "@mui/material";
import {Variant} from "../../../../types/types";


interface BetboardTableLabelProps {
    label: string
    color?: string
    fontWeight?: string
    variant?: Variant
}

export const BetboardTableLabel = (
    {label, color, variant, fontWeight}: BetboardTableLabelProps) => {
    const theme = useTheme();

    return (
        <Typography
            component="span"
            variant={variant as Variant || "caption"}
            fontWeight={fontWeight || "600"}
            pl={0.5}
            color={color || theme.palette.warning.light}
        >
            {label}
        </Typography>
    )
}